export default __webpack_public_path__ + "static/media/goshen90.011eae7e.jpg";